import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Grid } from "semantic-ui-react";

import * as actions from "../../actions";
import * as util from "../../shared/utility";
import ProjectBreadcrumb from "../breadcrumb/ProjectBreadcrumb";
import StandardTableHeader from "../UI/StandardHeader";

class InvoiceList extends React.Component {
  componentDidMount() {
    const { projectid } = this.props.match.params;
    this.props.fetchInvoicesForProject(projectid);
  }

  componentWillUnmount() {
    this.props.unloadInvoices();
  }

  renderTable() {
    let invoiceslist = null;

    if (this.props.invoices.length !== 0) {
      invoiceslist = this.props.invoices
        .sort((a, b) =>
          b.lastUpdatedDateTime.localeCompare(a.lastUpdatedDateTime)
        )
        .map((invoice) => {
          return (
            <tr key={invoice.invoiceID}>
              <td className="mobile hidden">{invoice.invoiceID}</td>
              <td>
                <Link
                  className="item"
                  to={`/sales/invoices/edit/${invoice.invoiceID}`}
                >
                  <div className="item">{invoice.name}</div>
                </Link>
              </td>
              <td className="center aligned">{invoice.invoiceNumber}</td>
              <td className="center aligned mobile hidden">
                {util.utcStringToLocalDate(invoice.sendDateTime)}
              </td>
              <td className="center aligned mobile hidden">
                {util.utcStringToLocalDateTime(invoice.lastUpdatedDateTime)}
              </td>
              <td>
                <i
                  style={{ cursor: "pointer" }}
                  className="file pdf icon orange"
                  title="Download file preview."
                  onClick={() =>
                    this.props.previewInvoicePdf(invoice.invoiceID)
                  }
                />
              </td>
              <td>
                <i
                  style={{ cursor: "pointer" }}
                  className="file save icon blue"
                  title="Create file in project folder."
                  onClick={() =>
                    this.props.generateInvoicePdf(invoice.invoiceID)
                  }
                />
              </td>
              <td>
                <Link
                  className="item"
                  to={`/sales/invoices/delete/${invoice.invoiceID}`}
                  key={invoice.invoiceID}
                >
                  <i className="trash icon" title="Delete record." />
                </Link>
              </td>
            </tr>
          );
        });
    }

    return (
      <div>
        <table className="ui celled table unstackable">
          <thead>
            <tr>
              <th className="one wide mobile hidden">ID</th>
              <th className="six wide">Name</th>
              <th className="two wide center aligned">Invoice Number</th>
              <th className="three wide center aligned mobile hidden">Send</th>
              <th className="three wide center aligned mobile hidden">
                Changed
              </th>
              <th className="one wide center aligned" colSpan="3">
                Action
              </th>
            </tr>
          </thead>
          <tbody>{invoiceslist}</tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <StandardTableHeader headerLabel="Invoices">
                <ProjectBreadcrumb
                  projectID={this.props.match.params.projectid}
                  currentPath="Invoices"
                />
              </StandardTableHeader>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>{this.renderTable()}</Grid.Column>
          </Grid.Row>
        </Grid>
        {(() => {
          if (this.props.showmessage) {
            return (
              <div className="ui positive message">
                <i
                  className="close icon"
                  onClick={this.props.resetInvoicesMessage}
                />
                <div className="header">Response:</div>
                <p>{this.props.responsemessage}</p>
              </div>
            );
          }
        })()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    invoices: state.invoices.items,
    isMobile: state.utility.isMobile,
    responsemessage: state.invoices.responsemessage,
    showmessage: state.invoices.showmessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchInvoicesForProject: (id) =>
      dispatch(actions.fetchInvoicesForProject(id)),
    generateInvoicePdf: (id) => dispatch(actions.generateInvoicePdf(id)),
    previewInvoicePdf: (id) => dispatch(actions.previewInvoicePdf(id)),
    unloadInvoices: () => dispatch(actions.unloadInvoices()),
    resetInvoicesMessage: () => dispatch(actions.resetInvoicesMessage()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceList);
